import { render, staticRenderFns } from "./softwareLis.vue?vue&type=template&id=688a5df8&scoped=true&"
import script from "./softwareLis.vue?vue&type=script&lang=ts&"
export * from "./softwareLis.vue?vue&type=script&lang=ts&"
import style0 from "./softwareLis.vue?vue&type=style&index=0&id=688a5df8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688a5df8",
  null
  
)

export default component.exports